/* eslint-disable fp/no-mutation */
type MarketingScriptOutcome = 'error' | 'success';

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    duckbillHistoryEventsInstalled?: boolean;
    duckbillLogLoadPerf?: (message: string) => void;
    duckbillMarketingHtmlBegin?: (name: string) => void;
    duckbillMarketingHtmlCompleted?: number;
    duckbillMarketingHtmlExpected?: number | null;
    duckbillMarketingHtmlFinished?: (name: string, outcome: MarketingScriptOutcome) => void;
    duckbillMarketingScriptsReleased?: boolean;
    duckbillMarketingSessionActive?: boolean;
    duckbillMarketingSessionBegin?: () => void;
    duckbillMarketingSessionStartedAt?: number | null;
    duckbillRecordMarketingDebugEvent?: (name: string, detail?: Record<string, string>) => void;
    duckbillTryMarketingLoadEnd?: () => void;
  }
}

const getBrowserWindow = (): Window | undefined => (typeof window === 'undefined' ? undefined : window);

export const isAnalyticsReleased = (): boolean => Boolean(getBrowserWindow()?.duckbillMarketingScriptsReleased);

export const logAnalyticsLoad = (message: string): void => {
  const browserWindow = getBrowserWindow();

  if (browserWindow?.duckbillLogLoadPerf) {
    browserWindow.duckbillLogLoadPerf(message);
    return;
  }

  if (typeof performance === 'undefined') {
    // eslint-disable-next-line no-console
    console.info(`[duckbill:load] ${message}`);
    return;
  }

  // eslint-disable-next-line no-console
  console.info(`[duckbill:load] ${new Date().toISOString()} (+${Math.round(performance.now())}ms) ${message}`);
};

export const releaseDeferredMarketingScripts = (reason: string): void => {
  const browserWindow = getBrowserWindow();

  if (!browserWindow) {
    return;
  }

  browserWindow.duckbillMarketingSessionBegin?.();
  browserWindow.duckbillMarketingScriptsReleased = true;
  browserWindow.duckbillRecordMarketingDebugEvent?.('marketing_release', { reason });
  logAnalyticsLoad(`Releasing deferred marketing scripts (GTM, Customer.io): ${reason}`);
};
